export const USER_SIGN_UP = 'APP/SIGN_UP/USER'
export const USER_SIGN_UP_SUCCESS = 'APP/SIGN_UP/USER_SUCCESS'
export const USER_SIGN_UP_ERROR = 'APP/SIGN_UP/USER_ERROR'
export const SIGN_UP_CLEAN_UP = 'APP/SIGN_UP/CLEAN_UP'
